<!--
@name 博士教育-应用心理学管理博士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容  -->
    <div class="content">
      <!--  项目亮点 -->
      <div class="cont-item">
        <div class="title-image">项目亮点</div>
        <div class="advantage">
          <p class="advantage-title">严谨的课程体系</p>
          <p>
            遵循国际商学院协会（AACSB)标准设置课程，以商业推动应用心理产业发展视角，引入全球跨界一创新-新产业的教学体系。</p>
          <p class="advantage-title">正规办学资质</p>
          <p>AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。</p>
          <p class="advantage-title">中外联合培养</p>
          <p> 国内一流大学师资及业内专家强强联合，法国高校教授鼎力加持。</p>
          <p class="advantage-title">项目制“应用心理产业创新营”，产业项目的孵化</p>
          <p>将参与的实践项目深挖、孵化、产出应用心理产业的硕果。</p>
          <p class="advantage-title">心理学与商科的深度融合</p>
          <p>通过应用心理学知识在商科中的运用，商业管理将更加科学、高效和人性化。</p>
        </div>
      </div>
      <!-- 项目亮点 -->
      <!-- 专业介绍 -->
      <div class="cont-item">
        <div class="title-image">课程背景</div>
        <div class="selector-indent">
          经济全球化及中法“一带一路”的战略合作背景下，法国布雷斯特高等商学院开设的应用心理学与管理博士学位课程旨在帮助学员获取世界前沿的应用心理学与管理发展视野、思维、工具和方法，同时打造资源生态，培养把握时代脉搏、具备突破性拓拓展中国应用心理产业大蓝海事业的创新人才。
        </div>
        <div class="selector-indent">
          应用心理学与管理学博士学位属专业博士学位，其着眼点专注于应用，区别于学术性博士，主要面对的是非心理学专业的跨学科专业人士。应用心理学与管理博士课程设计是以心理学科学的基本理论体系为本，以应用心理学的基本研究方法及工具为框架，辅之以目前国际前沿的研究与案例，让学习者既能建立心理科学基础，又能快速地在心理产业上实践与作为，进而真正达成应用学习深造与事业发展的目标。
        </div>
      </div>
      <!--  专业介绍 -->
      <!-- 培养方式 -->
      <!--    <div class="cont-item">-->
      <!--      <div class="title-image">培养方式</div>-->
      <!--      <div class="selector-indent">-->
      <!--        法国布雷斯特高等商学院应用心理学与管理硕士专业采用线上和线下教学、自主学习和毕业论文相结合的方式进行为期1.5年的学习。毕业季时组织学生集体去法国参加研修及毕业典礼。-->
      <!--      </div>-->
      <!--    </div>-->
      <!-- 培养方式 -->
      <!-- 课程内容 -->
      <div class="cont-item">
        <div class="title-image">课程内容</div>
        <p>
          课程设置以学习者的实际需求为核心，将心理学的各种理念、工具运用到管理实践中，注重理论与实践、中西文化融合、知己与知人相结合，让学习者收获新知、新能、新观，全方位为学习者的需求提供解决方案。</p>
        <p>
          课程设计的鲜明特点在于充分了解现代管理经济学理论和实践的同时，扎实学习心理学知识，并贴近中国当代热点，旨在确保学员能将所学的心理学、管理经济学知识及时高效地用于实践管理工作中。</p>
      </div>
      <!-- 课程设置 -->
      <div class="cont-item">
        <div class="title-image">课程设置</div>
        <img src="@/assets/images/personRain/dapm-course.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dapm-course01.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dapm-course02.png" alt="" class="course-img"/>
      </div>
      <!-- 课程设置 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>具有硕士研究生学位或者研究生同等学历，心理学相关专业优先。</p>
        <p>具有十年以上工作经验或者五年以上管理经验的高级管理者，企业家或者心理学相关专业的从业人员。</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">部分师资</div>
        <p>
          郁俊莉：管理学博士。现任北京大学教授，博士生导师。北京大学中国新兴产业创新研究中心主任。广东省发展和改革委员会学术委员会委员。国家区域发展战略和新兴产业研究专家。教育部新世纪优秀人才。 </p>
        <p>姜正新：工商管理硕士、经济学博士、教授，曾任职中国联通集团有限公司副总经理，党组成员。现任法国布雷斯特高等商学院中国区总负责人，伟东云教育集团副董事长。
        </p>
        <p>
          李英武：中国人民大学心理学系副教授、硕士生导师，清华大学公共领导力研究中心博士后、北京师范大学心理学院应用心理学博士、中国人民大学国家发展与战略研究院研究员、清华大学公共领导力研究中心兼职研究员、中组部领导干部考试与测评技术专家组核心专家、中国民用航空局民航机长及其关键岗位心理素质评估专家委员会首席专家。
        </p>
        <p>杨彦平：华东师范大学心理测量研究中心博士、西南大学心理学院从事认知心理学方向博士后研究先后承担过国家教育部、中国教育学会的子课题研究在《心理科学》等杂志发表文章10多篇。
        </p>
        <p>
          戴黔锋：盛道咨询集团总裁、复旦大学-香港城市大学联合培养博士、人力资源管理、企业战略管理、组织变革专家、清华大学、上海交大、浙江大学、北京大学、复旦大学等多所院校特聘讲师、复旦MBA课程、交大连锁总裁班、HR总监创新班讲师、浙大钜子班讲师、上海交通大学安泰学院MBA校外导师。
        </p>
        <p>
          刘亮：上海市浦东新区精神卫生中心，临床心理科主任、中德高级心理治疗师连续培训项目（家庭治疗组)中方教师、中国心理卫生协会心理治疗与咨询专委会家庭治疗学组委员兼副秘书长、同济大学附属精神卫生中心心身医学与心理治疗研修项目负责人及讲师、上海“家之源”家庭研究院，家庭治疗师、上海市精神卫生中心，精神科医师、哈佛大学医学院，精神医学联合培养博士、同济大学医学院，精神病与精神卫生博士、同济大学医学院，临床医学学士。
        </p>
        <p>徐红红：北京大学医学部临床心理学博士、北京大学医学心理学系讲师、美国加州大学洛杉矶分校(UCLA)婚姻家庭研究中心联合培养博士、多家英文学术期刊的审稿专家、中国心理学会，医学心理学专业委员会秘书。
        </p>
        <p>
          陈俊雄：在香港为私营机构，如香港地铁公司、阿迪达斯等提供培训及顾问服务，并在香港和澳门的政府和非营利组织提供EAP咨询和培训、美国婚姻与家庭治疗协会（AAMFT)教育联络官、麦吉尔大学教育学院法律与心理学系客座教授、加拿大洛基山学院科罗拉多专业心理学院临床心理学博士。
        </p>
        <p>陈福中：对外经济贸易大学国际经济贸易学院副教授、博士生导师、博士后合作导师、政治经济学系主任、中国人民大学经济学博士、Journal
          ofConsumer Affairs（Indexed by SSCI)编委、中国政治经济学学会、中国消费经济学会理事。
        </p>
        <p>佘贤君：北京师范大学心理学系发展与教育心理学博士、中央电视台广告中心市场部主任、中国广告协会电视委员会副秘书长、出版《触发非理性消费》、《激活消费者心理需求》等热销书籍。
        </p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">应用心理学与管理博士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容  -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduYyxlBs',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9E/wKgCEmfFwT-APk4JAcpNNdx9k8U084.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduYyxlBs.vue